import React from "react"
//import containerStyles from "./container.module.css"
import { Link } from "gatsby"
export default ({page, related}) => {

  let title;
  switch (page){
    case 'introduction':
    title='Introduction';
    break;
    case 'index':
    title='Home Page';
    break;
    default:
    title='Components';
  }

  let headers = []
  headers.push({
    slug: 'usage',
    title: 'Usage',
    children: [
      //{slug: 'usage', title: 'Usage'},
      {slug: 'features', title: 'Features'},
      {slug: 'api', title: 'API'},
    ]
  });

  return (
    <nav className="cd-toc" aria-label="Secondary navigation">
      <ul className="ml-2">

        <li>
          <a href="#usage">{title}</a>
          {page!=='introduction' && page!=='index'?
          <ul>
            {
              headers.map((header, index) => {
                return (
                  <li key={"h2"+index}>
                    <a href={`#${header.slug}`}>{header.title}</a>
                    {
                      header.children?
                        <ul>
                          {
                            header.children.map((h3, index) => {
                              return <li key={"h3"+index}><a href={`#${h3.slug}`}>{h3.title}</a></li>
                            })
                          }
                        </ul>:null
                    }
                  </li>
                )
              })
            }

            {related && (related.length>1)?
            <li key={'related'}>
              <a>Related</a>
              <ul>
                {
                  related.map((item, index) => (
                    <li key={`related-${index}`}><a href={'#'+item}>{item}</a></li>
                  ))
                }
              </ul>
            </li>:null}

          </ul>:null}
        </li>

      </ul>
    </nav>
  )

  /*
  <template v-for="(header, i) in headers">
    <li :key="'h2' + i">
      <a :href="`#${header.slug}`">{{header.title}}</a>
      <ul v-if="header.children">
        <template v-for="(h3, i) in header.children">
          <li :key="'h3' + i"><a :href="`#${h3.slug}`">{{h3.title}}</a></li>
        </template>
      </ul>
    </li>
  </template>
  */

}
